import { inject } from "@angular/core";
import { ResolveFn, Router } from "@angular/router";
import { map, of, tap } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ObjectUtils } from "~app/common/utils/object-utils";

export type ExternVirkeskopskontraktRouteParamsDto = {
    avtalId: number;
    kontraktId: number;
};

export type GetVirkeskopskontraktRouteParamsQuery = {
    atgardBeteckning: string;
    kontraktnummer: string;
};

export const virkeskopskontraktSearchParamsResolver: ResolveFn<GetVirkeskopskontraktRouteParamsQuery> = (route, _state) => {
    const apiClientService = inject(ApiClientService);
    const router = inject(Router);

    const beteckning = route.queryParamMap.get("atgard");
    const kontraktnummer = route.queryParamMap.get("kontraktnummer");

    const req: GetVirkeskopskontraktRouteParamsQuery = {
        atgardBeteckning: beteckning,
        kontraktnummer: kontraktnummer
    };

    if (ObjectUtils.isNullOrUndefined(beteckning) &&
        ObjectUtils.isNullOrUndefined(kontraktnummer)) {
        return of(req);
    }

    return apiClientService.post<GetVirkeskopskontraktRouteParamsQuery, ExternVirkeskopskontraktRouteParamsDto>(`externvirkeskop/kontrakt`, req).pipe(
        tap(res => {
            if (!res) {
                return;
            }

            router.navigate([
                "/virkeskop/avtal",
                res.avtalId
            ], {
                queryParams: {
                    kontraktId: res.kontraktId
                }
            });
        }),
        map(() => req)
    );
};
